<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";

  export let item = {
    type: "time",
    required: true,
    hours: [],
    hours: ["6", "7", "8", "10", "12"],
    minutes: ["00", "15", "30", "45"],
    exclude: ["6:30 AM", "10:00 PM"],
    from: "8:00 AM",
    to: "10:15 PM",
    range: 15,
    title: "",
    placeholder: "",
    description: "",
  };

  export let index = 0;
  let hour = "";
  let minute = "";
  let clock = "AM";
  let include = [];

  function splitTime(time) {
    let arrTime = time.split(" ");
    let splitTime = arrTime[0].split(":");
    return {
      hour: parseInt(splitTime[0]),
      minute: parseInt(splitTime[1]),
      clock: arrTime[1],
    };
  }

  function fromAmPmTo24(date) {
    let time = splitTime(date);
    let hour = time.hour;
    let minute = time.minute;
    if (time.clock === "PM" && hour !== 12) hour = hour + 12;
    if (time.hour === 12 && time.clock === "AM") hour = 0;
    return {
      time: `${hour}:${minute === 0 ? "00" : minute}`,
      hour,
      minute,
    };
  }

  function from24ToAmPm(date) {
    let time = splitTime(date);
    let hour = time.hour;
    let minute = time.minute;
    let clock = "AM";
    if (hour >= 12) {
      hour = hour - 12;
      clock = "PM";
    }
    if (hour === 0) {
      hour = 12;
    }

    return {
      time: `${hour}:${minute === 0 ? "00" : minute} ${clock}`,
      hour,
      minute,
      clock,
    };
  }

  function setInclude(from, to, range) {
    //this variables are in 24 format
    let currentTime = fromAmPmTo24(from);

    //first iteration of time in am/pm format
    include = [from24ToAmPm(currentTime.time).time];

    let count = 0;
    //00:00 to 14:30
    while (currentTime.time !== fromAmPmTo24(to).time) {
      let hour = currentTime.hour;
      let minute = currentTime.minute;

      if (minute + range >= 60) {
        hour++;
        minute = minute + range - 60;
      } else {
        minute = minute + range;
      }

      currentTime = {
        time: `${hour}:${minute === 0 ? "00" : minute}`,
        hour,
        minute,
      };
      include.push(from24ToAmPm(currentTime.time).time);
      count++;
      //exit while loop if stupid bug present
      if (count === 100) break;
    }
  }

  onMount(() => {
    if (item.from && item.to && item.range) {
      setInclude(item.from, item.to, item.range);
    }
    $result[index] = "";
  });

  function storeResult() {
    $result[index] = {
      time: `${hour}:${minute} ${clock}`,
      hour,
      minute,
      clock,
    };
  }

  function setTime(value, type) {
    if (type === "hour") {
      let intHour = parseInt(value);
      if (intHour >= 1 && intHour <= 12) {
        hour = value;
      } else {
        hour = "";
      }
    } else if (type === "min") {
      let intMin = parseInt(value);
      if (intMin >= 0 && intMin <= 59) {
        if (intMin <= 9 && intMin > 0) {
          minute = "0" + intMin;
        } else if (value === "00") {
          minute = "00";
        } else {
          minute = intMin.toString();
        }
      } else {
        minute = "";
      }
    }
    storeResult();
  }

  function setFullTime(time) {
    let { hour, minute, clock } = splitTime(time);
    $result[index] = {
      time: time,
      hour,
      minute: minute === 0 ? "00" : minute,
      clock,
    };
  }
</script>

<div class="time-container">
  {#if include.length > 0}
    <select
      class="include-select"
      name="include-selector"
      on:change={(e) => setFullTime(e.target.value)}
    >
      <option value="" disabled selected>{item.placeholder || ""}</option>
      {#each include as time}
        {#if item.exclude && item.exclude.length > 0 && item.exclude.includes(time)}
          {null}
        {:else}
          <option value={time}>{time}</option>
        {/if}
      {/each}
    </select>
  {:else}
    <input
      class="left-input"
      type="number"
      placeholder="hour"
      min="1"
      max="12"
      bind:value={hour}
      on:input={(e) => setTime(e.target.value, "hour")}
    />
    :
    <input
      class="right-input"
      type="number"
      placeholder="minute"
      bind:value={minute}
      on:input={(e) => setTime(e.target.value, "min")}
    />
    <select
      class="clock"
      name="clock"
      bind:value={clock}
      on:change={storeResult}
    >
      <option value="AM">AM</option>
      <option value="PM">PM</option>
    </select>
  {/if}
  <!-- {#if item.hours && item.hours.length > 0}
    <select
      class="left-select"
      name="hour-selector"
      bind:value={hour}
      on:change={storeResult}
    >
      <option value="" disabled selected>hour</option>
      {#each item.hours as h}
        {#if item.exclude && item.exclude.length > 0 && item.exclude.includes(`${h}:${minute} ${clock}`)}
          {null}
        {:else}
          <option value={h}>{h}</option>
        {/if}
      {/each}
    </select>
  {:else}
    <input
      class="left-input"
      type="number"
      placeholder="hour"
      min="1"
      max="12"
      bind:value={hour}
      on:input={(e) => setTime(e.target.value, "hour")}
    />
  {/if}
  :
  {#if item.minutes && item.minutes.length > 0}
    <select
      class="right-select"
      name="minute-selector"
      bind:value={minute}
      on:change={storeResult}
    >
      <option value="" disabled selected>minute</option>
      {#each item.minutes as m}
        {#if item.exclude && item.exclude.length > 0 && item.exclude.includes(`${hour}:${m} ${clock}`)}
          {null}
        {:else}
          <option value={m}>{m}</option>
        {/if}
      {/each}
    </select>
  {:else}
    <input
      class="right-input"
      type="number"
      placeholder="minute"
      bind:value={minute}
      on:input={(e) => setTime(e.target.value, "min")}
    />
  {/if}
  <select class="clock" name="clock" bind:value={clock} on:change={storeResult}>
    {#if item.exclude && item.exclude.length > 0 && item.exclude.includes(`${hour}:${minute} AM`)}
      {null}
    {:else}
      <option value="AM">AM</option>
    {/if}
    {#if item.exclude && item.exclude.length > 0 && item.exclude.includes(`${hour}:${minute} PM`)}
      {null}
    {:else}
      <option value="PM">PM</option>
    {/if}
  </select> -->
</div>

<!-- <select name="minutes">
  <option value="15">15</option>
  <option value="30">30</option>
  <option value="45">45</option>
</select> -->
<style>
  input {
    width: 100%;
    margin-bottom: 0px;
  }
  .right-input {
    margin-left: 5px;
  }
  .left-input {
    margin-right: 5px;
  }
  .include-select {
    margin-bottom: 0px;
    width: 100%;
  }
  .clock {
    margin-left: 5px;
    margin-bottom: 0px;
    width: 150px;
  }
  .time-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }
</style>
